import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';

export class AuthorizationTypeMap {
  static toIcon(value: AuthorizationType): string {
    switch (value) {
      case AuthorizationType.BASIC:
        return 'key';
      case AuthorizationType.OAUTH_2:
        return 'lock';
      default:
        return 'highlight_off';
    }
  }
}
